import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  NotificationDetailsModel,
  NotificationItemModel,
} from '../../models/notifications';

interface INotificationService {
  getNotifications: (
    queryString?: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<NotificationItemModel[]>>;
  getNotificationDetails: (
    notificationId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<NotificationDetailsModel>>;
}

export const notificationService: INotificationService = {
  getNotifications(queryString, axiosConfig) {
    return ajax.get<NotificationItemModel[]>(
      `${config.merchantsApiUrl}/odata/notifications?${queryString}`,
      axiosConfig,
    );
  },

  getNotificationDetails(notificationId, axiosConfig) {
    return ajax.get<NotificationDetailsModel>(
      `${config.merchantsApiUrl}/notifications/${notificationId}/details`,
      axiosConfig,
    );
  },
};
